import React, { useState } from "react";
import axios from "axios";
import Whats from "./Whats";
import "../styles/Formulario.scss";
import CircularProgress from "@mui/material/CircularProgress";

const Formulario = () => {
  const phoneContact = 5215588093678;
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [formStatus, setFormStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const isFormValid = name && phone && email;

  const handleNameChange = (e) => setName(e.target.value);
  const handlePhoneChange = (e) => setPhone(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = { name, phone, email };

    setIsLoading(true);
    try {
      if (isFormValid) {
        const response = await axios.post(
          "https://ovitsolucionesweb.com/formulario/formulario.php",
          formData
        );
        setFormStatus("Formulario enviado exitosamente.");
        setIsLoading(false);
        console.log(response.data);
      } else {
        alert("Introduzca los datos del formulario");
        setIsLoading(false);
      }
    } catch (error) {
      setFormStatus("Error al enviar el formulario.");
      setIsLoading(false);
      console.error(error);
    }
  };

  return (
    <section className="formContainerMain" id="formulario">
      <div className="formBG" aria-hidden="true">
        <div className="formGrid" />
        <div className="formGlow formGlow--1" />
        <div className="formGlow formGlow--2" />
      </div>

      <div className="formShell p-5">
        <form className="formContainer p-5" onSubmit={handleSubmit}>
          <div className="formHeader text-center">
            <span className="formKicker">OVIT Soluciones Web</span>
            <h2 className="formTitle">Contáctanos</h2>
            <p className="formSubtitle">
              Cuéntanos lo básico y te respondemos rápido por WhatsApp.
            </p>
          </div>

          <div className="mt-3">
            <label className="formLabel" htmlFor="nombre">
              Nombre
            </label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              className="form-control inputCustom"
              placeholder="Tu nombre"
              value={name}
              onChange={handleNameChange}
            />
          </div>

          <div className="mt-3">
            <label className="formLabel" htmlFor="telefono">
              Teléfono
            </label>
            <input
              type="number"
              id="telefono"
              name="telefono"
              className="form-control inputCustom"
              placeholder="Tu teléfono"
              value={phone}
              onChange={handlePhoneChange}
            />
          </div>

          <div className="mt-3">
            <label className="formLabel" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control inputCustom"
              placeholder="Tu correo"
              value={email}
              onChange={handleEmailChange}
            />
          </div>

          <div className="d-flex justify-content-center flex-column gap-2 mt-4 text-center">
            <span className="textTermns">
              Al dar click e ingresar tus datos, aceptas nuestras Políticas de Privacidad.
            </span>

            <button className="btn btnAgent" type="submit" disabled={isLoading}>
              {isLoading ? "Enviando..." : "Envíanos tus datos"}
            </button>

            <div className="text-center mt-1">
              {isLoading && <CircularProgress sx={{ color: "#18f0ff" }} />}
            </div>

            <div className="formDivider">
              <span>O contáctanos por</span>
            </div>

            <Whats
              classStyle="btn btnWhats"
              message="Hola, quiero más información acerca de sus servicios"
              phoneNumber={phoneContact}
              text="WhatsApp"
            />
          </div>

          {formStatus && <div className="formStatus mt-3 text-center">{formStatus}</div>}
        </form>
      </div>
    </section>
  );
};

export default Formulario;
